var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Injectable } from '@angular/core';
import { AuthenticatedApiService } from './authenticated-api.service';
import { AdminUserBuilder } from '../builders/adminUser-builder';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
export class AdminUsersApiService {
    constructor(authenticatedApi) {
        this.authenticatedApi = authenticatedApi;
    }
    listAdminUsers(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.get(`/adminuser/list`, payload).toPromise();
            return AdminUserBuilder.buildAdminUsersList(response);
        });
    }
    listAllAdminUsers(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.get(`/adminuser/list_all`, payload).toPromise();
            return response.users;
        });
    }
    getAdminUser(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const { user } = yield this.authenticatedApi.get(`/adminuser/${id}`).toPromise();
            return AdminUserBuilder.buildAdminUser(user);
        });
    }
    updateAdminUser(adminUser) {
        return __awaiter(this, void 0, void 0, function* () {
            let payload = {
                alias: adminUser.alias,
                active: adminUser.active,
                everywhere: adminUser.everywhere,
                can_api: adminUser.canApi,
                id_lot: adminUser.idLot,
                app_lot: adminUser.appLot,
                level: adminUser.level,
                password: adminUser.password,
                name: adminUser.name,
                name_2: adminUser.name_2,
                nif: adminUser.nif,
                email: adminUser.email,
                phone: adminUser.phone,
                date_modified: adminUser.dateModified,
                id_permissions_group: adminUser.id_permissions_group
            };
            const response = yield this.authenticatedApi.put(`/adminuser/${adminUser.id}`, JSON.stringify(payload)).toPromise();
            return response.status;
        });
    }
    createUser(adminUser) {
        return __awaiter(this, void 0, void 0, function* () {
            let payload = {
                alias: adminUser.alias,
                active: adminUser.active,
                everywhere: adminUser.everywhere,
                can_api: adminUser.canApi,
                id_lot: adminUser.idLot,
                app_lot: adminUser.appLot,
                level: adminUser.level,
                password: adminUser.password,
                name: adminUser.name,
                name_2: adminUser.name_2,
                nif: adminUser.nif,
                email: adminUser.email,
                phone: adminUser.phone,
                date_creation: adminUser.dateCreation,
                date_modified: adminUser.dateModified,
                id_permissions_group: adminUser.id_permissions_group
            };
            const response = yield this.authenticatedApi.post('/adminuser', JSON.stringify(payload)).toPromise();
            return response;
        });
    }
}
AdminUsersApiService.ɵfac = function AdminUsersApiService_Factory(t) { return new (t || AdminUsersApiService)(i0.ɵɵinject(i1.AuthenticatedApiService)); };
AdminUsersApiService.ɵprov = i0.ɵɵdefineInjectable({ token: AdminUsersApiService, factory: AdminUsersApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(AdminUsersApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }]; }, null); })();
//# sourceMappingURL=adminUsers-api.service.js.map